import Pagination from './pagination';
import { PaginationProps } from './rc-pagination/Interface';
export default Pagination;
export { PaginationProps };
